export default "__VITE_ASSET__CilpvBzA__"